 <bulk-upload-test-results  [uploadType]="voucherService.voucherUploadType"></bulk-upload-test-results>
  
  

